import locale from "@bonliva-crm/locale";
import { ConfirmDialogOptions } from "./ConfirmDialogOptions";
import { ConfirmDialogAction } from "./utils";

export type OkCancelResult = "ok" | "cancel";

export class OkCancelDialogOptions extends ConfirmDialogOptions<OkCancelResult> {
  actions: Array<ConfirmDialogAction<OkCancelResult>> = [
    {
      title: locale.Cancel,
      icon: null,
      type: "regular" as const,
      value: "cancel" as OkCancelResult,
      isClose: true
    },
    {
      title: locale.OK,
      icon: null,
      type: "primary" as const,
      value: "ok" as OkCancelResult
    }
  ];

  constructor(
    public title: string = locale.AreYouSure,
    public message: string | null = null
  ) {
    super();
  }
}
